(function() {
  var AccessController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.ValidationExampleController = (function(superClass) {
    extend(ValidationExampleController, superClass);

    function ValidationExampleController(scope, transitions, service, q, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.q = q;
      this.http = http;
      this.save = bind(this.save, this);
      ValidationExampleController.__super__.constructor.call(this, 'validation_example', this.http);
      this.scope.validateOnLoad = true;
      this.scope.fullpage = true;
      this.scope.title = 'Official Validation Example';
      this.scope.obj = {
        wash: '',
        kaylee: ''
      };
      this.scope.jayne = {
        selected_name: '',
        options: ['Jayne Cobb', 'Hero of Canton', 'The Man They Call Jayne', 'Chain of Command Holder', 'Adam Baldwin']
      };
      this.scope.simon = [];
      this.scope.validateOnLoad = true;
      this.scope.tooltipPlacement = 'left';
      this.scope.save = this.save;
    }

    ValidationExampleController.prototype.save = function() {
      return this.service.save(this.scope.obj.wash, this.scope.obj.kaylee, this.scope.jayne.selected_name, this.scope.simon);
    };

    return ValidationExampleController;

  })(AccessController);

}).call(this);
